import dayjs from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useTableContext } from '../../contexts/TableContext';
import RoutesApp from '../../routes';

//Servicios
import { DeclaracionesService } from '../../services/api';

//Componentes
import Spinner from '../spinner/Spinner';
import DJMVSearch from './DJMVSearch';

//Estilos
import right_arrow from '../../assets/imgs/next.png';
import pencil from '../../assets/imgs/edit.png';

function DJMVSearchContainer() {
    const { masters, SearchParameters } = useGlobalContext();
    const { state } = useTableContext();
    const tablePage = useMemo(() => state.DJMVPage, [state.DJMVPage]);
    const [loader, setLoader] = useState(false);
    const [tableData, setTableData] = useState(buildTableData());
    let apiTablePages;

    useEffect(() => {
        const getDJMVSearchCuantity = async () => {
            try {
                setLoader(true);

                const DJMVSearchCuantity =
                    await DeclaracionesService.totalRecords({
                        ...SearchParameters.declaraciones,
                        tipo: 9,
                    });

                if (DJMVSearchCuantity) {
                    apiTablePages = DJMVSearchCuantity.data;

                    getDJMVSearch();
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getDJMVSearchCuantity();
    }, [tablePage, SearchParameters.declaraciones]);

    async function getDJMVSearch() {
        try {
            setLoader(true);

            const DJMVSearch = await DeclaracionesService.search({
                ...SearchParameters.declaraciones,
                tipo: 9,
                pagina: tablePage,
            });

            if (DJMVSearch) {
                setTableData(buildTableData(DJMVSearch.data, apiTablePages));
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    }

    /**Funcion que crea el objeto para crear la tabla resultado del buscador de DJMVs */
    function buildTableData(data = [], tablePages) {
        return {
            title: 'Declaraciones de DJMV',
            headers: [
                'ID',
                'Viñedo',
                'Titulares',
                'Fecha',
                'Departamento',
                'Seccional',
                ' ',
            ],
            tablePages,
            pagination: 10,
            pageType: 'DJMVPage',
            data:
                data.length > 0
                    ? data.map((dj) => {
                          return {
                              id: `${dj.serie}-M-${dj.numero}`,
                              viniedo: dj.viniedo,
                              titulares: dj.titulares,
                              fecha: dayjs(dj.fecha).format('DD-MM-YYYY'),
                              departamento: masters.Departments?.find(
                                  (ht) => ht.id === dj.departamento
                              )?.nombre.replaceAll('_', ' '),
                              kilosTotales: dj.seccional,
                              icons: (
                                  <div>
                                      <Link
                                          to={
                                              RoutesApp.Declaraciones
                                                  .cosechaProbable + dj.id
                                          }
                                          className="table-icon_container"
                                      >
                                          <img
                                              className="table-icon"
                                              src={right_arrow}
                                              title="Visualizar"
                                              alt="Visualizar"
                                          />
                                      </Link>
                                  </div>
                              ),
                          };
                      })
                    : [],
        };
    }

    return loader ? <Spinner /> : <DJMVSearch tableData={tableData} />;
}

export default DJMVSearchContainer;
